// extracted by mini-css-extract-plugin
export default {"wrapper":"checks_wrapper__K2Wph","center":"checks_center__uP6iK","checkItem":"checks_checkItem__QFWdA"};